(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name NotificacionesController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('NotificacionesController', NotificacionesController);

    NotificacionesController.$inject = ["NotificacionesService","$timeout","$location",'$anchorScroll'];

    function NotificacionesController(NotificacionesService,$timeout,$location,$anchorScroll)
    {

    	var vm = this;
    	vm.notificaciones = []
        vm.loading = false;
    	vm.sinleer = 0;

    	vm.getNotificaciones = function(){
    		vm.loading = true;
    		NotificacionesService.getNotificacionesCentro(function(data){
                vm.notificaciones = data.notificaciones;
    			NotificacionesService.sinleer = data.sin_leer;
                vm.sinleer = data.sin_leer;
    			vm.loading = false;
            });
    	}

    	vm.getNotificaciones();
               
    }


})();